// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"24819":"e8e6b0ccbb9dc525","59319":"7962c2083ebb8557","77174":"f86c7c75344ff597"}[chunkId] + ".css";
};